import { styled } from '@mui/material';

export const PageW = styled('div')`
  display: flex;
  padding-left: 34px;
  padding-top: 64px;
  flex-direction: column;
  position: relative;

  @media (max-width: 1023px) {
    padding: 88px 0px 80px 0px;
  }
`;

export const PageContent = styled('div')`
  width: 100%;
  display: flex;

  @media (min-width: 1920px) {
    justify-content: center;
  }
`;

export const ContentInner = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ColumnsW = styled('div')`
  display: flex;
`;

export const LeftColumn = styled('div')`
  width: 560px;
  margin-right: 24px;

  @media (max-width: 1280px) and (min-width: 1024px) {
    width: 450px;
  }

  @media (max-width: 1023px) {
    width: 100%;
    margin-right: 0px;
  }
`;

export const RightColumn = styled('div')`
  width: 520px;

  @media (max-width: 1280px) and (min-width: 1024px) {
    width: 436px;
  }

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

export const FlexW = styled('div')`
  display: flex;
  justify-content: space-between;
`;

export const DesktopView = styled('div')`
  display: flex;
  width: 100%;
  @media (max-width: 1023px) {
    display: none;
  }
`;

export const MobileView = styled('div')`
  display: none;
  @media (max-width: 1023px) {
    display: block;
  }
`;
